import { render, staticRenderFns } from "./StreamPlayer.vue?vue&type=template&id=6e87fb2d&scoped=true&"
import script from "./StreamPlayer.vue?vue&type=script&lang=js&"
export * from "./StreamPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e87fb2d",
  null
  
)

export default component.exports